import type { VariantProps } from 'class-variance-authority';

import { cva } from 'class-variance-authority';

export { default as FilterButton } from './Button.vue';

export interface FilterButtonProps {
	isActive?: boolean;
	numberOfAppliedFilters?: number;
	showNumberOfAppliedFilters?: boolean;
	label?: string;
	variant?: FilterButtonVariant;
}

export const filterButtonVariants = cva(
	'size-min max-h-11 gap-1 px-3 py-[15px] font-sans text-sm font-normal data-[is-active=true]:border-primary-light-2 data-[is-applied=true]:border-primary-light-1 data-[is-active=true]:bg-primary-light-2 data-[is-applied=true]:bg-primary-light-3 md:max-h-[50px]',
	{
		variants: {
			variant: {
				default: 'flex-row',
				reverse: 'flex-row-reverse'
			}
		},
		defaultVariants: {
			variant: 'default'
		}
	}
);

export type FilterButtonVariant = VariantProps<
	typeof filterButtonVariants
>['variant'];
